import * as Yup from 'yup';

export const SignUpBasicInfoSchema = Yup.object().shape({
  businessName: Yup.string()
    .min(1)
    .required('Please provide your business name'),
  businessType: Yup.string().required('Please provide your business type'),
  registrationNumber: Yup.string()
    .min(1)
    .required('Please provide your business registration number'),
  email: Yup.string().email().required('email is required'),
  phoneNumber: Yup.string()
    .min(8)
    .required('Please provide your phone number'),
});

export type SignUpBasicInfoDataType = Yup.InferType<typeof SignUpBasicInfoSchema>;

type InitialValues = {
  businessName: string;
  businessType: string;
  registrationNumber: string;
  email: string;
  phoneNumber: string;
};

export const signUpBasicInfoInitialValues: InitialValues = {
  businessName: '',
  businessType: '',
  registrationNumber: '',
  email: '',
  phoneNumber: '',
};


export interface BasicInfoSliderInterface {
  businessName: string;
  businessType: string;
  registrationNumber: string;
  email: string;
  phoneNumber: string;
}
